var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PageWithFooter',{scopedSlots:_vm._u([{key:"content",fn:function(){return [_c('PageHeader',{staticClass:"default-gutter mb-6"}),_c('HelpCenterBreadcrumbs'),_c('v-container',{staticClass:"default-gutter my-12",attrs:{"fluid":""}},[_c('HelpCenterContentHeader'),_c('HelpCenterContent'),_c('HelpCenterAdditionalResources')],1)]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }